import nexKeyMarkUrl from "@/assets/nexkey-n.webp";
import { cn } from "@/lib/utils";

export function NexKeyMark({
  className,
  eager = false,
}: {
  className?: string;
  eager?: boolean;
}) {
  return (
    <img
      src={nexKeyMarkUrl}
      alt=""
      aria-hidden="true"
      draggable={false}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={cn("block shrink-0 object-contain", className)}
    />
  );
}

export function NexKeyLogo({
  className,
  markClassName,
  uppercase = false,
  eager = false,
}: {
  className?: string;
  markClassName?: string;
  uppercase?: boolean;
  eager?: boolean;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <NexKeyMark className={cn("h-12 w-12", markClassName)} eager={eager} />
      <span className="font-display font-bold tracking-normal">
        <span className="text-foreground">{uppercase ? "NEXKEY" : "NexKey"}</span>
        <span className="text-muted-foreground">.GG</span>
      </span>
    </span>
  );
}